import { Grid } from "@mui/material";
import { Spinner } from "../../../components/Loading/Spinner";
import CreateNivelModal from "../../../components/Table/OAS/Niveles/CreateNivelModal";
import DeleteNivelesModal from "../../../components/Table/OAS/Niveles/DeleteNivelesModal";
import EditNivelModal from "../../../components/Table/OAS/Niveles/EditNivelModal";
import HeaderNiveles from "../../../components/Table/OAS/Niveles/HeaderNiveles";
import NivelesTable from "../../../components/Table/OAS/Niveles/NivelesTable";
import { useNiveles } from "../../../context/SuperAdmin/OASContexts/NivelesContext";

const NivelesPage = () => {
  const { isLoading } = useNiveles();

  if (isLoading) {
    return <Spinner msg="Cargando por favor espere..." />;
  }

  return (
    <Grid
      container
      spacing={4}
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        pt: 3,
        color: "#005559",
      }}
    >
      {/* Agregar o eliminar niveles */}
      <Grid item>
        <HeaderNiveles />
      </Grid>

      {/* Tabla de niveles */}
      <Grid item>
        <NivelesTable />
      </Grid>

      {/* Modal para confirmar eliminar niveles de la organización */}
      <Grid item>
        <DeleteNivelesModal />
      </Grid>

      {/* Modal para crear un nivel en una organización */}
      <Grid item>
        <CreateNivelModal />
      </Grid>

      {/* Modal para editar un nivel en una organización */}
      <Grid item>
        <EditNivelModal />
      </Grid>
    </Grid>
  );
};

export default NivelesPage;
